module.exports = __webpack_public_path__ + "img/yrjt.9779420a.png";